export default __webpack_public_path__ + "static/media/IconDesc_LiquidTurboFuel_Pipe.256.232ebac8.png";